<template lang="pug">
.dashboard-page

  DashboardHeader(
    :nombre="nombreUsuario"
  )

  //- ULTIMAS NOTICIAS
  Noticias
  br
  //- FILA SUPERIOR
  .dashboard-info-grid

    NuevosEmpleados

    CumpleaniosHoy

  //- CURSOS TODO EL ANCHO
  MisCursos
  br
  //- PENDIENTES DEL JEFE
  PendientesJefe(
    v-if="perfilVacaciones !== 'usuario'"
  )

  //- PENDIENTES PERSONALES
  MisPendientes

</template>

<script>
import DashboardHeader from './kpis/dashboard/c_dashboard_header.vue'
import PendientesJefe from './kpis/dashboard/c_pendiente_jefe.vue'
import MisPendientes from './kpis/dashboard/c_mis_pendientes.vue'
import NuevosEmpleados from './kpis/dashboard/c_nuevos_empleados.vue'
import CumpleaniosHoy from './kpis/dashboard/c_cumpleanios_hoy.vue'
import MisCursos from './kpis/dashboard/c_mis_cursos.vue'
import Noticias from './kpis/dashboard/c_noticias.vue'

export default {
  name: 'Dashboard',
  components: {
    DashboardHeader,
    PendientesJefe,
    MisPendientes,
    NuevosEmpleados,
    CumpleaniosHoy,
    MisCursos,
    Noticias
  },
  data () {
    return {
      perfilVacaciones:localStorage.getItem('perfilVacaciones'),
      nombreUsuario: localStorage.getItem('nombre')
    }
  },
  computed: {
    totalPendientesJefe () {
      return this.pendientesJefe.reduce((total, item) => {
        return total + item.cantidad
      }, 0)
    }
  },
  methods: {
    abrirPendiente (item) {
      if (item.ruta) {
        this.$router.push(item.ruta)
      }
    },
    verEmpleado (empleado) {
      this.$router.push('/empleados/' + empleado.id)
    },
    continuarCurso (curso) {
      this.$router.push('/cursos/' + curso.id)
    }
  }
}
</script>
<style scoped>
.dashboard-page {
  min-height: 100vh;
  padding: 24px;
  background: #f5f6f8;
}


/* ==========================================
   EMPLEADOS + CUMPLEAÑOS
   ========================================== */

.dashboard-info-grid {
  display: grid;

  grid-template-columns:
    minmax(0, 1fr)
    minmax(0, 1fr);

  gap: 20px;

  align-items: stretch;

  /* Espacio antes de pendientes como jefe */
  margin-bottom: 24px;
}


/*
  Obliga a los dos componentes a ocupar
  exactamente la misma altura.
*/
.dashboard-info-grid > * {
  height: 100%;
  min-height: 240px;
}


/* ==========================================
   RESPONSIVE
   ========================================== */

@media (max-width: 900px) {

  .dashboard-info-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-info-grid > * {
    min-height: auto;
  }

}


@media (max-width: 600px) {

  .dashboard-page {
    padding: 12px;
  }

}
</style>



// WEBPACK FOOTER //
// Component_Dashboard_KPI_jefe_New.vue?1b92210c